import { useState, useEffect } from 'react';
import deTranslations from '../translations/de.json';

function useTranslation() {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    // Check URL parameters first, then localStorage, then default to 'en'
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    const storedLang = localStorage.getItem('chronolog-language');
    
    let selectedLang = 'en';
    
    if (langParam) {
      selectedLang = langParam;
      // Store the URL parameter choice
      localStorage.setItem('chronolog-language', langParam);
    } else if (storedLang) {
      selectedLang = storedLang;
      // Update URL to reflect stored language preference
      if (storedLang === 'de') {
        const url = new URL(window.location);
        url.searchParams.set('lang', 'de');
        window.history.replaceState({}, '', url);
      }
    }
    
    if (selectedLang === 'de') {
      setCurrentLanguage('de');
      setTranslations(deTranslations);
    } else {
      setCurrentLanguage('en');
      setTranslations({});
    }
  }, []);

  // Helper function to get nested translation
  const t = (path, fallback = '') => {
    if (currentLanguage === 'en') {
      return fallback; // Return fallback for English (original text)
    }
    
    const keys = path.split('.');
    let value = translations;
    
    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key];
      } else {
        return fallback; // Return fallback if translation not found
      }
    }
    
    return typeof value === 'string' ? value : fallback;
  };

  return {
    currentLanguage,
    isGerman: currentLanguage === 'de',
    t,
    translations
  };
}

export default useTranslation; 